export const enum CustomAttributeType {
    SINGLE_CHOICE = "single_choice",
    DATE = "date",
    OPEN_TEXT_FIELD = "open_text_field",
    YEAR_OF_ENTRY = "static.year_of_entry",
    AREA_OF_STUDY = "static.area_of_study",
}
